const transcriptionTitleExtensions = new Set([
  'aac',
  'avi',
  'flac',
  'flv',
  'm4v',
  'm4a',
  'mkv',
  'mov',
  'mp3',
  'mp4',
  'mpeg',
  'mpg',
  'ogg',
  '3gp',
  'wav',
  'webm',
  'wmv',
]);

export function stripKnownTranscriptionTitleExtension(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return '';

  const lastDot = trimmed.lastIndexOf('.');
  if (lastDot <= 0) return trimmed;

  const ext = trimmed.slice(lastDot + 1).toLowerCase();
  if (!/^[a-z0-9]+$/.test(ext)) return trimmed;
  if (!transcriptionTitleExtensions.has(ext)) return trimmed;

  const withoutExt = trimmed.slice(0, lastDot).trim();
  return withoutExt || trimmed;
}
